import { Injectable } from "@angular/core";
import { IOrderAuditService } from "../IOrderAuditService";
import { CoreOrderAudit } from "../../model/core/CoreOrderAudit";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class OrderAuditPromiseService implements IOrderAuditService {
  public abstract getOrderAudit(orderId: string, protocol: string): Promise<Array<CoreOrderAudit>>;
}
